<template>
  <v-container style="min-height: calc(100vh - 124px);">
    <v-row>
      <v-col cols="12" md="12">
        <v-tabs
          v-model="tabsurat"
          show-arrows>
          <v-tab href="#tab-data" class="text-capitalize">
            <v-badge
              color="red"
              inline>
              <v-icon>mdi-text-box-check-outline</v-icon>
              Data
            </v-badge>
          </v-tab>
          <v-tab href="#tab-draft" class="text-capitalize">
            <v-icon>mdi-text-box-check-outline</v-icon> Draft Surat
          </v-tab>
        </v-tabs>
        <v-tabs-items :touchless="true" v-model="tabsurat">
          <v-tab-item value="tab-data">
            <v-card flat>
              <alertsp class="my-1" :alertdata="alertgetdata"></alertsp>
              <div class="text-center" v-if="loading.getdata">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </div>
              <v-card-text class="px-0">
                <v-row justify="center" v-if="detaildata">
                  <v-col cols="12">
                    <div class="text-subtitle-1 font-weight-black">
                      {{ detaildata.kd_sk }}
                    </div>
                    <v-chip
                      class="my-1"
                      :color="detaildata.status_sk == 'siap' ? 'green' : 'red'"
                      text-color="white"
                      small>
                      {{ detaildata.status_sk }}
                    </v-chip>
                    <div class="text-subtitle-2">
                      {{ detaildata.nama_hal }}
                    </div>
                    <div class="text-subtitle-2 font-weight-bold">
                      {{ detaildata.judul_sk }}
                    </div>
                    <div class="text-subtitle-2">
                      at.<b>{{ detaildata.tgl_ajukan }}</b>
                    </div>
                    <v-divider class="my-3"></v-divider>
                    <div class="caption font-weight-black mb-1">
                      Pemohon:
                    </div>
                    <div class="text-subtitle-2">
                      <div v-if="dataprofile.nama">
                        <b>{{ dataprofile.nama }}</b>
                      </div>
                      ({{ detaildata.user_sk }})
                    </div>
                  </v-col>
                </v-row>
                <v-row justify="center" v-if="!detaildata">
                  <v-col cols="12">
                    Data tidak ditemukan!
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-draft" v-if="detaildata">
            <v-card flat>
              <!-- file surat -->
              <v-card-text
                class="px-0"
                v-if="detaildata.isdraf === 'true' && detaildata.file_sk !== ''">
                <div>
                  <iframe
                    :src="getPdfView(detaildata.urlfile)"
                    class="pdf-embed-surat mt-3"
                    frameborder="0">
                  </iframe>
                </div>
                <div>
                  <a :href="getPdfView(detaildata.urlfile)" target="_blank">Preview Draft Surat</a>
                </div>
              </v-card-text>
              <!-- non file surat -->
              <v-card-text
                class="px-0"
                v-if="detaildata.isdraf === 'false' || detaildata.file_sk === ''">
                <div class="border-solid-thin text-justify min-width-scroll-x">
                  <div class="min-width-710">
                    <v-row justify="center" align="center">
                      <v-col cols="3" md="3" class="text-center">
                        <img :src="require('../../assets/' + prefix + '/logopnb.jpg')" height="100"/>
                      </v-col>
                      <v-col cols="9" md="9" class="text-center">
                        <div class="title text-uppercase">KEMENTRIAN PENDIDIKAN, KEBUDAYAAN, <br/> RISET, DAN TEKNOLOGI</div>
                        <div class="title text-uppercase">POLITEKNIK NEGERI BALI</div>
                        <div>
                          {{ staticdata.alamat }}<br/>
                          Telp. {{ staticdata.phone }} Fax. {{ staticdata.fax }}, laman: {{ staticdata.laman }}, email: {{ staticdata.email }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-divider class="mb-3"></v-divider>
                    <v-row justify="center" align="center">
                      <v-col cols="12">
                        <div class="text-center text-underline subtitle-3">SURAT KEPUTUSAN DIREKTUR POLITEKNIK NEGERI BALI</div>
                        <div class="text-center">Nomor: {{ detaildata.no_sk ? detaildata.no_sk : '_______/_______/_______/_______' }}</div>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col cols="12">
                        <table class="tbl-align-top mb-3 width100">
                          <tr>
                            <td>Tentang</td>
                            <td>:</td>
                            <td><b>{{ detaildata.judul_sk }}</b></td>
                          </tr>
                          <tr>
                            <td colspan="3" class="text-center">
                              <b>DIREKTUR POLITEKNIK NEGERI BALI</b>
                            </td>
                          </tr>
                          <tr>
                            <td>Menimbang</td>
                            <td>:</td>
                            <td><div v-html="detaildata.txt_timbang"></div></td>
                          </tr>
                          <tr>
                            <td>Mengingat</td>
                            <td>:</td>
                            <td><div v-html="detaildata.txt_ingat"></div></td>
                          </tr>
                          <tr>
                            <td colspan="3" class="text-center">
                              <b>MEMUTUSKAN</b>
                            </td>
                          </tr>
                          <tr>
                            <td>Menetapkan</td>
                            <td>:</td>
                            <td><div v-html="detaildata.txt_tetap"></div></td>
                          </tr>
                        </table>
                        <p>Demikian keputusan ini dibuat untuk dilaksanakan, dengan catatan akan diubah atau diperbaiki seperlunya bila ada kekeliruan dikemudian hari.</p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6"></v-col>
                      <v-col cols="12" md="6" class="text-right">
                        <div v-if="detaildata.status_sk !== 'siap'">
                          Jimbaran, {{ new Date() | dateToIndo }}
                        </div>
                        <div v-if="detaildata.status_sk === 'siap'">
                          Jimbaran, {{ new Date(detaildata.tgl_sk) | dateToIndo }}
                        </div>
                        <div>{{ detaildata.user_as_spm ? detaildata.user_as_spm : '-' }}</div>
                        <div v-if="detaildata.status_sk === 'siap'">
                          <qrcode-vue :value="detaildata.urlqr" size="80" level="H" class="d-inline"/>
                        </div>
                        <div>{{ detaildata.username_spm ? detaildata.username_spm : '-' }}</div>
                        <div>NIP. {{ detaildata.user_spm ? detaildata.user_spm : '-' }}</div>
                      </v-col>
                    </v-row>
                    <v-row class="mt-5" v-if="detaildata.no_sk">
                      <v-col cols="12" md="12">
                        <div class="d-flex align-top">
                          <v-divider vertical></v-divider>
                          <div class="d-inline ml-3 caption">
                            <div>Dicetak menggunakan e-Office PNB</div>
                            <div>Scan QRCode untuk verifikasi keaslian surat</div>
                          </div>
                        </div>
                        <!-- <v-divider vertical></v-divider> -->
                      </v-col>
                    </v-row>
                    <v-divider class="my-5"></v-divider>
                    <v-row justify="center" align="center">
                      <v-col cols="12">
                        <div class="subtitle-3">LAMPIRAN SURAT KEPUTUSAN DIREKTUR POLITEKNIK NEGERI BALI</div>
                        <div>
                          <table class="tbl-align-top mb-3 width100">
                            <tr>
                              <td>Nomor</td>
                              <td>:</td>
                              <td><b>{{ detaildata.no_sk }}</b></td>
                            </tr>
                            <tr>
                              <td>Tentang</td>
                              <td>:</td>
                              <td><b>{{ detaildata.judul_sk }}</b></td>
                            </tr>
                          </table>
                        </div>
                        <div>
                          <v-simple-table class="tbl-txt-small">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <td>No</td>
                                  <td>Nama</td>
                                  <td>NIP/NIM</td>
                                  <td>Gol.</td>
                                  <td>Jabatan</td>
                                  <td>Honor</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(tim, index) in detaildata.tims" :key="index">
                                  <td>{{ index + 1 }}</td>
                                  <td>{{ tim.tim_name }}</td>
                                  <td>{{ tim.tim_user }}</td>
                                  <td>{{ tim.tim_gol }}</td>
                                  <td>{{ tim.tim_role }}</td>
                                  <td>{{ tim.tim_honor }}</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6"></v-col>
                      <v-col cols="12" md="6" class="text-right">
                        <div v-if="detaildata.status_sk !== 'siap'">
                          Jimbaran, {{ new Date() | dateToIndo }}
                        </div>
                        <div v-if="detaildata.status_sk === 'siap'">
                          Jimbaran, {{ new Date(detaildata.tgl_sk) | dateToIndo }}
                        </div>
                        <div>{{ detaildata.user_as_spm ? detaildata.user_as_spm : '-' }}</div>
                        <div v-if="detaildata.status_sk === 'siap'">
                          <qrcode-vue :value="detaildata.urlqr" size="80" level="H"/>
                        </div>
                        <div>{{ detaildata.username_spm ? detaildata.username_spm : '-' }}</div>
                        <div>NIP. {{ detaildata.user_spm ? detaildata.user_spm : '-' }}</div>
                      </v-col>
                    </v-row>
                    <v-row class="mt-5" v-if="detaildata.no_sk">
                      <v-col cols="12" md="12">
                        <div class="d-flex align-top">
                          <v-divider vertical></v-divider>
                          <div class="d-inline ml-3 caption">
                            <div>Dicetak menggunakan e-Office PNB</div>
                            <div>Scan QRCode untuk verifikasi keaslian surat</div>
                          </div>
                        </div>
                        <!-- <v-divider vertical></v-divider> -->
                      </v-col>
                    </v-row>
                  </div>
                </div> 
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <!-- form -->
        <div class="my-3" v-if="detaildata">
          <v-form
            ref="formupdatesurat"
            v-model="formadd.valid"
            lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-select
                  dense
                  v-if="detaildata.status_sk === 'permohonan'"
                  :disabled="!canchange"
                  :items="liststatus"
                  name="statussurat"
                  :rules="[rules.required]"
                  v-model="updatesurat.status_sk"
                  label="Status Surat*">
                </v-select>
                <v-text-field
                  dense
                  v-if="detaildata.status_sk !== 'permohonan'"
                  :disabled="true"
                  :readonly="true"
                  :value="detaildata.status_sk"
                  label="Status Surat"
                  name="status_sk">
                </v-text-field>
              </v-col>
              <v-col cols="12" v-if="updatesurat.status_sk === 'tolak'">
                <v-text-field
                  dense
                  :disabled="!canchange"
                  v-model="updatesurat.acc_ka_note"
                  label="Catatan penolakan*"
                  :rules="[rules.required]"
                  name="acc_ka_note">
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <alertsp :alertdata="alertdata"></alertsp>
                <div class="text-center" v-if="loading.update">
                  <v-progress-circular
                    :width="3"
                    color="red"
                    indeterminate>
                  </v-progress-circular>
                </div>
                <v-btn
                  tile
                  depressed
                  large
                  color="primary"
                  class="mr-2"
                  :to="{ name: 'SKDosen', query: { tab: 'tab-acc-unit' } }">
                  Kembali
                </v-btn>
                <v-btn
                  tile
                  depressed
                  large
                  v-if="!loading.update && canchange"
                  :disabled="!formadd.valid"
                  color="success"
                  class="mr-2"
                  @click="submitUpdate">
                  Proses
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { getDateTodayId } from '../../utils/dateFormatCustom.js';
import { getGdriveView } from '@/plugins/utils';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import { sha256, sha224 } from 'js-sha256';

export default {
  name: 'SKUnitDetail',
  props: ['kodesurat'],
  data: () => ({
    selectedItem: 1,
    alertgetdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
      changest: false,
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    apision: process.env.VUE_APP_APISION,
    hash: process.env.VUE_APP_HASH,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    prefix: process.env.VUE_APP_PREFIX,
    publickey: '123',
    detaildata: null,
    dataprofile: null,
    liststatus: ['proses', 'tolak'],
    datalist: [],
    dataaccunit: [],
    dataaccdir: [],
    updatesurat: {
      status_sk: '',
      kd_sk: '',
      no_sk: '',
      kode_hal: '',
      judul_sk: '',
    },
    listcategory: ['job-fair', 'motivation'],
    liststatusacc: [
      {
        value: 'permohonan',
        label: 'Perlu Acc',
      },
      {
        value: 'history',
        label: 'History Acc',
      },
      {
        value: 'semua',
        label: 'Semua',
      },
    ],
    liststatusdir: [
      {
        value: 'proses',
        label: 'Perlu Acc',
      },
      {
        value: 'history',
        label: 'History Acc',
      },
      {
        value: 'semua',
        label: 'Semua',
      },
    ],
    filterunit: {
      search: '',
      status: 'permohonan',
    },
    filterdir: {
      search: '',
      status: 'proses',
    },
    panduan: null,
    paramkamus: {
      keyword: '',
      limit: 15,
      offset: 0,
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    formadd: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    infiniteId: +new Date(),
    wdayshow: true,
    tabsurat: null,
    canchange: true,
  }),
  mounted() {
    // this.getKamus();
    if (this.kodesurat) {
      this.getDetailSurat();
    }
    // update title
    this.$store.commit('UPDATE_TITLE', this.kodesurat);
    // get data
    // this.getAccUnit();
    // check woday
    // this.checkWday();
  },
  filters: {
    dateToIndo(value) {
      return getDateTodayId(value);
    },
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'wday',
      'staticdata',
    ]),
  },
  methods: {
    getProfile(data) {
      // console.log(data);
      const strhex = data.user_sk +
        '' + this.hash;
      // console.log(strhex);
      const hashactv = sha256(strhex).toUpperCase();
      this.dataprofile = [];
      this.axios
        .get(
          this.apision + '/pegawai/' + data.user_sk + '&' + hashactv,
          {
            params: {},
            headers: {},
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.responseCode === '00') {
              this.dataprofile = resdata.profile;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPdfView(url) {
      return getGdriveView(url);
    },
    getDetailSurat() {
      if (this.tokenscr) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/sk/accunit/' + this.kodesurat,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.detail.length > 0) {
                  this.detaildata = resdata.data.detail[0];
                  this.detaildata.tims = resdata.data.tims;
                  this.detaildata.urlttd = this.api + '/images/spm/' + this.detaildata.file_spm;
                  this.detaildata.urlqr = this.baseurl + '/verifikasi/' + this.detaildata.kd_sk;
                  this.detaildata.urlfile = this.api + '/upload/media/sk/' + this.detaildata.file_sk;
                  this.updatesurat.kd_sk = this.detaildata.kd_sk;
                  this.updatesurat.status_sk = this.detaildata.status_sk;
                  this.updatesurat.no_sk = this.detaildata.no_sk;
                  this.updatesurat.kode_hal = this.detaildata.kode_hal;
                  this.updatesurat.judul_sk = this.detaildata.judul_sk;
                  this.updatesurat.acc_ka_note = this.detaildata.acc_ka_note;
                  this.checkCanChange();
                  this.getProfile(this.detaildata);
                  // this.getTandatangan();
                } else {
                  this.alertgetdata.show = true;
                  this.alertgetdata.type = 'error';
                  this.alertgetdata.text = 'Data tidak ditemukan!';
                }
              } else {
                this.alertgetdata.show = true;
                this.alertgetdata.type = 'error';
                this.alertgetdata.text = resdata.message;
              }
            } else {
              this.alertgetdata.show = true;
              this.alertgetdata.type = 'error';
              this.alertgetdata.text = 'Internal services error!';
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertgetdata.show = true;
            this.alertgetdata.type = 'error';
            this.alertgetdata.text = 'Internal services error!';
            this.loading.getdata = false;
          });
      }
    },
    submitUpdate() {
      this.alertdata.show = false;
      if (this.$refs.formupdatesurat.validate()) {
        if (this.tokenscr) {
          // console.log(this.updatesurat);
          this.loading.update = true;
          this.axios
            .put(
              this.api + '/api/sk/accunit',
              qs.stringify(
                this.updatesurat,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Permohonan surat "' + this.updatesurat.kd_sk + '" berhasil diperbaharui!';
                  // this.getDetailSurat();
                  // this.$root.$emit('app-getnotifiaction');
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.update = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.update = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    checkCanChange() {
      this.canchange = true;
      const denystatus = ['siap', 'tolak', 'proses'];
      if (denystatus.indexOf(this.updatesurat.status_sk) >= 0) {
        this.canchange = false;
      }
    },
    getAccUnit() {
      if (this.tokenscr) {
        this.loading.changest = true;
        this.axios
          .get(
            this.api + '/api/suratlain/acc',
            {
              params: {
                status: this.filterunit.status,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.dataaccunit = resdata.data;
              }
            }
            this.loading.changest = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.changest = false;
          });
      }
    },
    checkWday() {
      const now = new Date();
      const datenow = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
      if (this.wday) {
        const wdaytgl = this.wday.date ? this.wday.date : '';
        // console.log(wdaytgl);
        if (datenow !== wdaytgl) {
          // get data
          this.getWorday(datenow);
        }
      } else {
        // get data
        this.getWorday(datenow);
      }
    },
    getWorday(datenow) {
      this.axios
        .get(
          this.api + '/public/wordday',
          {
            params: {},
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              if (resdata.data.length > 0) {
                const rdata = resdata.data[0];
                const pdata = {
                  id_vocab: rdata.id_vocab,
                  vocab_en: rdata.vocab_en,
                  part_of: rdata.part_of,
                  date: datenow,
                };
                this.$store.commit('UPDATE_WDAY', pdata);
                this.wdayshow = true;
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getKamusFilter() {
      this.paramkamus.offset = 0;
      this.datalist = [];
      this.infiniteId += 1;
    },
    getKamus($state) {
      this.axios
        .get(
          this.api + '/public/kamus',
          {
            params: this.paramkamus,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              if (resdata.data.length > 0) {
                this.paramkamus.offset += this.paramkamus.limit;
                this.datalist.push(...resdata.data);
                if (this.datalist.length < this.paramkamus.offset) {
                  if ($state !== false) {
                    $state.complete();
                  }
                } else {
                  if ($state !== false) {
                    $state.loaded();
                  }
                }
              } else {
                if ($state !== false) {
                  $state.complete();
                }
              }
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
    QrcodeVue,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  $main-color: #216185;

  .item-list-style{
    border-bottom: solid thin #BDBDBD;
  }
  .item-list-style:hover{
    color: $main-color;
    border-color: $main-color;
  }
  a.link-list-style{
    text-decoration: none;
    color: black;
  }
</style>
